import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (this.isAndroidWebView()) {
      this.showAlert()
    }
  }

  isAndroidWebView() {
    const ua = navigator.userAgent || navigator.vendor || window.opera
    const isAndroid = /Android/i.test(ua)
    const hasWV = /\bwv\b/.test(ua) || /\bVersion\/[\d.]+/i.test(ua)
    const isInAppBrowser = /(FBAN|FBAV|Instagram|GSA|Gmail|Line|LinkedInApp|Twitter)/i.test(ua)

    return isAndroid && (hasWV || isInAppBrowser)
  }

  showAlert() {
    const div = document.createElement("div")
    div.className = "fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4"
    div.innerHTML = `
      <div class="bg-white rounded-2xl shadow-xl p-6 max-w-sm text-center">
        <h2 class="text-lg font-semibold mb-3 text-gray-900">In-app browser detected</h2>
        <p class="text-sm text-gray-700 mb-5">
          It looks like you're viewing this page inside an app (e.g. Gmail, Instagram).
          For the best experience, please open it directly in Chrome.
        </p>
        <a href="intent://${location.host}${location.pathname}#Intent;scheme=https;package=com.android.chrome;end"
           class="inline-block px-4 py-2 bg-green-600 text-white rounded-full hover:bg-green-700 transition-all">
          Open in Chrome
        </a>
      </div>
    `
    document.body.appendChild(div)
  }
}
